// @flow
import { QRConfActionTypes } from './constants';

type QRConfAction = { type: string, payload: {} | string };

// common success
export const QRConfApiResponseSuccess = (actionType: string, data: any): QRConfAction => ({
    type: QRConfActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const QRConfApiResponseError = (actionType: string, error: string): QRConfAction => ({
    type: QRConfActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const updateQRConf = (QRConf: any): QRConfAction => ({
    type: QRConfActionTypes.UPDATE_QR_CONF,
    payload: QRConf
})

export const generateQR = (params: any): QRConfAction => ({
    type: QRConfActionTypes.GENERATE_QR,
    payload: params
})

export const resetQRConf = (): QRConfAction => ({
    type: QRConfActionTypes.RESET,
    payload: {},
});

